import React from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';

import useTeamMembers from 'hooks/useTeamMembers';

import TeamMember from './TeamMember';

import './Team.scss';

export default function Team() {
  const { teamMembers, isLoading } = useTeamMembers();

  if (isLoading) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="team"
    >
      <Helmet>
        <title>Team - DuskBreakers</title>
        <meta
          name="description"
          content="Come meet the DuskBreakers team! We are so excited to bring our skills and creative vision to the world of blockchain."
        />
      </Helmet>

      <section
        className="
        d-flex
        align-items-center
        justify-content-center
        team-description
      "
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="mb-5">Team</h1>
              <div className="pb-5">
                <p>
                  Our team has fundamentally shaped gaming, storytelling, and the creator economy in
                  our past careers, building world class interactive platforms such as Twitch, 96
                  Next, Wakandacon, The Harbinger, and winning multiple Emmy Awards along the way.
                </p>
                <p>
                  We are so excited to come together and bring our unique skillsets and creative
                  vision to the exhilarating world of blockchain and NFTs.
                </p>
                <p>
                  {`If you're interested in joining our team, please check out our `}
                  <a href="https://jobs.lever.co/Metatheory" target="_new">
                    open positions
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-container">
        <div className="container">
          <div className="row d-flex g-4">
            {teamMembers.map((teamMember) => {
              return (
                <div className="col-md-6 col-lg-3" key={teamMember.id}>
                  <TeamMember teamMember={teamMember} />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </m.main>
  );
}
